<template>
    <div class="form-check">
        <input
            v-bind="$attrs"
            type="checkbox"
            ref="checkbox"
            :class="{'form-check-input':true,'is-invalid':errors.length}"
            v-model="checkboxValue"
            :id="id"
        />

        <label
            v-if="label"
            :for="id"
            class="form-check-label"
            v-html="label"
        />
        <label
            v-else-if="hasSlot"
            :for="id"
            class="form-check-label"
        >
            <slot></slot>
        </label>

        <small v-if="errors.length === 0 && description !== null" class="form-text text-muted" v-text="description"></small>
        <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
    </div>
</template>

<script>

export default {

    computed: {
        checkboxValue: {
            get() {
                return this.value;
            },
            set(newvalue) {
                this.$emit('input', newvalue);
            },
        },
        hasSlot() {
            return !!this.$slots['default'];
        },
    },

    inheritAttrs:false,

    methods:{
        focusField(){
            this.$refs.checkbox.focus()
        },
    },

    mounted() {
        if (this.focus === true) {
            setTimeout(() => this.focusField(), 200);
        }
    },

    props:{
        description:{
            type:String,
            default:null,
        },
        errors:{
            type:Array,
            default:() => [],
        },
        focus:{
            type:Boolean,
            default:false,
        },
        id:{
            type:String,
            default(){
                return `checkbox-${this._uid}`
            },
        },
        label:String,
        value:Boolean,
    },
}

</script>
